import React from 'react'

const ProductCategory = React.lazy(() => import('pages/ProductCategory/ProductCategory'));
const ProductCategoryAdd = React.lazy(() => import('pages/ProductCategory/ProductCategoryAdd'));
const ProductCategoryEdit = React.lazy(() => import('pages/ProductCategory/ProductCategoryEdit'));
const ProductCategoryDetail = React.lazy(() => import('pages/ProductCategory/ProductCategoryDetail'));

const ProductCategoryRoutes = [
    {
        path: '/product-category',
        exact: true,
        name: 'Ngành hàng',
        function: 'MD_PRODUCTCATEGORY_VIEW',
        component: ProductCategory,
    },
    {
        path: '/product-category/add',
        exact: true,
        name: 'Thêm mới',
        function: 'MD_PRODUCTCATEGORY_ADD',
        component: ProductCategoryAdd,
    },
    {
        path: '/product-category/edit/:id',
        exact: true,
        name: 'Chỉnh sửa',
        function: 'MD_PRODUCTCATEGORY_EDIT',
        component: ProductCategoryEdit,
    },
    {
        path: '/product-category/detail/:id',
        exact: true,
        name: 'Chi tiết',
        function: 'MD_PRODUCTCATEGORY_VIEW',
        component: ProductCategoryDetail,
    },
]

export default ProductCategoryRoutes
